var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/render-entries.j2"] = require( "macros/contentful/render-entries.j2" );
dependencies["macros/contentful-module-spacing.j2"] = require( "macros/contentful-module-spacing.j2" );
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/giveaway-module.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful/render-entries.j2", false, "core/templates/macros/contentful/giveaway-module.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderEntries")) {
var t_4 = t_1.renderEntries;
} else {
cb(new Error("cannot import 'renderEntries'")); return;
}
context.setVariable("renderEntries", t_4);
env.getTemplate("macros/contentful-module-spacing.j2", false, "core/templates/macros/contentful/giveaway-module.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("getBottomMarginClasses")) {
var t_8 = t_5.getBottomMarginClasses;
} else {
cb(new Error("cannot import 'getBottomMarginClasses'")); return;
}
context.setVariable("getBottomMarginClasses", t_8);
env.getTemplate("macros/slider-macros.j2", false, "core/templates/macros/contentful/giveaway-module.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("create_slider_arrows")) {
var t_12 = t_9.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_12);
var macro_t_13 = runtime.makeMacro(
[], 
["entry", "isSpecialtyShop", "isGiveawayModule", "entryloop", "isLazy"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", kwargs.hasOwnProperty("entry") ? kwargs["entry"] : {});
frame.set("isSpecialtyShop", kwargs.hasOwnProperty("isSpecialtyShop") ? kwargs["isSpecialtyShop"] : false);
frame.set("isGiveawayModule", kwargs.hasOwnProperty("isGiveawayModule") ? kwargs["isGiveawayModule"] : false);
frame.set("entryloop", kwargs.hasOwnProperty("entryloop") ? kwargs["entryloop"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("isLazy", kwargs.hasOwnProperty("isLazy") ? kwargs["isLazy"] : false);
var t_14 = "";var t_15;
t_15 = runtime.contextOrFrameLookup(context, frame, "entry");
frame.set("module", t_15, true);
if(frame.topLevel) {
context.setVariable("module", t_15);
}
if(frame.topLevel) {
context.addExport("module", t_15);
}
t_14 += "\n    ";
var t_16;
t_16 = (lineno = 7, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "module"),"sys.id",""]));
frame.set("giveawayID", t_16, true);
if(frame.topLevel) {
context.setVariable("giveawayID", t_16);
}
if(frame.topLevel) {
context.addExport("giveawayID", t_16);
}
t_14 += "\n\n    ";
t_14 += "\n\n    <div class=\"";
t_14 += runtime.suppressValue((lineno = 11, colno = 39, runtime.callWrap(t_8, "getBottomMarginClasses", context, [runtime.contextOrFrameLookup(context, frame, "module"),runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop")])), env.opts.autoescape);
t_14 += " c-giveaway-module dom-giveaway-module\">\n\n        <div class=\"js-giveaway-module\" data-giveaway-module-id=\"";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "giveawayID"), env.opts.autoescape);
t_14 += "\">\n\n            <div class=\"c-giveaway-module__inner js-giveaway-module__inner\">\n\n                ";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "module")),"fields")),"components");
if(t_19) {var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("entry", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
t_14 += "\n                    ";
var t_21;
t_21 = runtime.contextOrFrameLookup(context, frame, "loop");
frame.set("moduleentryloop", t_21, true);
if(frame.topLevel) {
context.setVariable("moduleentryloop", t_21);
}
if(frame.topLevel) {
context.addExport("moduleentryloop", t_21);
}
t_14 += "\n                    ";
var t_22;
t_22 = (lineno = 19, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_20,"coming_soon"])) && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish");
frame.set("isComingSoonGiveawayOnSmallish", t_22, true);
if(frame.topLevel) {
context.setVariable("isComingSoonGiveawayOnSmallish", t_22);
}
if(frame.topLevel) {
context.addExport("isComingSoonGiveawayOnSmallish", t_22);
}
t_14 += "\n\n                    ";
if(!runtime.contextOrFrameLookup(context, frame, "isComingSoonGiveawayOnSmallish")) {
t_14 += "\n\n                        ";
t_14 += runtime.suppressValue((lineno = 23, colno = 38, runtime.callWrap(t_4, "renderEntries", context, [t_20,runtime.contextOrFrameLookup(context, frame, "module"),runtime.contextOrFrameLookup(context, frame, "entryloop"),runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop"),runtime.contextOrFrameLookup(context, frame, "moduleentryloop"),runtime.contextOrFrameLookup(context, frame, "isLazy"),runtime.makeKeywordArgs({"isMobileSlider": false,"isFlex": false,"isGiveaway": true})])), env.opts.autoescape);
t_14 += "\n\n                    ";
;
}
t_14 += "\n\n                ";
;
}
}
frame = frame.pop();
t_14 += "\n\n            </div>\n\n            ";
t_14 += runtime.suppressValue((lineno = 31, colno = 33, runtime.callWrap(t_12, "create_slider_arrows", context, [runtime.makeKeywordArgs({"disablePrev": runtime.contextOrFrameLookup(context, frame, "True"),"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
t_14 += "\n\n        </div>\n\n    </div>";
;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
context.addExport("giveawayModule");
context.setVariable("giveawayModule", macro_t_13);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/giveaway-module.j2"] , dependencies)